import { Outlet } from "react-router-dom";
import AuthenticatedLayout from "@/pages/(authenticated)/layout";

// (authenticated) 配下で共有する layout。
// AuthenticatedLayout (FacilityProvider/LoadingProvider/SidebarProvider/Header/Sidebar 等) を
// 1 度だけ構築し、子 route は <Outlet /> 経由で render する。
//
// 認証ガード (AuthChecker) は app-shell.tsx の LayoutWrapper で全ルートに適用済み。
// ここで二重に LayoutWrapper を置かないこと。
export function ProtectedLayout() {
  return (
    <AuthenticatedLayout>
      <Outlet />
    </AuthenticatedLayout>
  );
}
